import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SelectField } from 'react-md'

import { getFrameTypes, getIsFetchingFrameTypes } from 'redux/reducers'
import { loadFrameTypes } from 'redux/actions'

class FrameTypeSelect extends Component {
  componentWillMount () {
    const { frameTypes, isFetchingFrameTypes, loadFrameTypes } = this.props
    if (!frameTypes.length && !isFetchingFrameTypes) {
      loadFrameTypes()
    }
  }

  render () {
    const {
      frameTypes,
      isFetchingFrameTypes,
      loadFrameTypes,
      input,
      meta,
      ...rest
    } = this.props

    return (
      <SelectField
        {...input}
        {...rest}
        menuItems={frameTypes.map(v => {
          switch (v.id) {
            case 1:
              return { id: v.id, name: 'Art Print' }
            case 2:
              return { id: v.id, name: 'Framed Print' }
            default:
              return { id: v.id, name: '' }
          }
        })}
        itemLabel='name'
        itemValue='id'
      />
    )
  }
}

FrameTypeSelect.propTypes = {
  frameTypes: PropTypes.array.isRequired,
  isFetchingFrameTypes: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  frameTypes: getFrameTypes(state),
  isFetchingFrameTypes: getIsFetchingFrameTypes(state)
})

export default connect(mapStateToProps, { loadFrameTypes })(FrameTypeSelect)



// WEBPACK FOOTER //
// ./src/containers/FrameTypeSelect/index.js